import { FC, ReactElement } from "react";
import { Popover, PopoverProps, SxProps, Theme } from "@mui/material";

interface IMenuPopover extends PopoverProps {
  open: boolean;
  sx?: SxProps<Theme>;
  anchorEl: Element | null;
}

const MenuPopover: FC<IMenuPopover> = ({
  open,
  children,
  sx,
  anchorEl,
  ...rest
}): ReactElement => {
  return (
    <Popover
      open={open}
      onClose={rest.onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      anchorEl={anchorEl}
      slotProps={{
        paper: {
          sx: {
            mt: 1.5,
            ml: 0.5,
            overflow: "inherit",
            width: 200,
            border: "none",
            boxShadow: "0px 3px 8px 0px #1A1A1A26",
            ...sx,
          },
        },
      }}
      {...rest}
    >
      {children}
    </Popover>
  );
};

export default MenuPopover;
